module.exports = __webpack_public_path__ + "img/bg2.8610b8a1.jpg";